import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { HEADER_MODIFY_TABLE_CONTENT_PROPERTY } from '@/corePagesModule/BaseTableContent/constants';
import { TableContentHeader } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';

const contentPropertyTypeAnnounce: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    {
      key: 'customerAnnounce-1',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerAnnounce-1'], propertyType: 'number' },
    },
    {
      key: 'customerAnnounce-2',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerAnnounce-2'], propertyType: 'number' },
    },
    {
      key: 'customerAnnounce-3',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerAnnounce-3'], propertyType: 'number' },
    },
    {
      key: 'inputDate',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['inputDate'], propertyType: 'string' },
    },
    {
      key: 'fileName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['fileName'], propertyType: 'string' },
    },
    {
      key: 'warehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'businessNumberNamedByUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumberNamedByUser'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'unit',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['unit'], propertyType: 'string' },
    },
    {
      key: 'customerNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerNumber'], propertyType: 'number' },
    },
    {
      key: 'customerName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerName'], propertyType: 'string' },
    },
    {
      key: 'deliveryDestinationNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['deliveryDestinationNumber'], propertyType: 'string' },
    },
    {
      key: 'deliveryDestinationName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['deliveryDestinationName'], propertyType: 'string' },
    },
    {
      key: 'registerBusiness',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    HEADER_MODIFY_TABLE_CONTENT_PROPERTY,
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: true,
  },
};

const contentPropertyTypeSalesResult: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    {
      key: 'saleQuantity',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['saleQuantity'], propertyType: 'number' },
    },
    {
      key: 'inputDate',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['inputDate'], propertyType: 'string' },
    },
    {
      key: 'fileName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['fileName'], propertyType: 'string' },
    },
    {
      key: 'warehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'businessNumberNamedByUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumberNamedByUser'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'unit',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['unit'], propertyType: 'string' },
    },
    {
      key: 'endUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['endUser'], propertyType: 'string' },
    },
    {
      key: 'customerNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerNumber'], propertyType: 'number' },
    },
    {
      key: 'customerName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['customerName'], propertyType: 'string' },
    },
    {
      key: 'deliveryDestinationNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['deliveryDestinationNumber'], propertyType: 'string' },
    },
    {
      key: 'deliveryDestinationName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['deliveryDestinationName'], propertyType: 'string' },
    },
    {
      key: 'registerBusiness',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    HEADER_MODIFY_TABLE_CONTENT_PROPERTY,
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: true,
  },
};

const contentPropertyTypeInventory: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    {
      key: 'inventory',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['inventory'], propertyType: 'number' },
    },
    {
      key: 'inputDate',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['inputDate'], propertyType: 'string' },
    },
    {
      key: 'fileName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['fileName'], propertyType: 'string' },
    },
    {
      key: 'warehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'manufacturer',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['manufacturer'], propertyType: 'string' },
    },
    {
      key: 'businessNumberNamedByUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumberNamedByUser'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'unit',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['unit'], propertyType: 'string' },
    },
    {
      key: 'registerBusiness',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    HEADER_MODIFY_TABLE_CONTENT_PROPERTY,
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: true,
  },
};

const contentPropertyTypeArrival: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    {
      key: 'arrivalAmount',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['arrivalAmount'], propertyType: 'number' },
    },
    {
      key: 'inputDate',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['inputDate'], propertyType: 'string' },
    },
    {
      key: 'fileName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['fileName'], propertyType: 'string' },
    },
    {
      key: 'warehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'manufacturer',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['manufacturer'], propertyType: 'string' },
    },
    {
      key: 'businessNumberNamedByUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumberNamedByUser'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'unit',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['unit'], propertyType: 'string' },
    },
    {
      key: 'registerBusiness',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    HEADER_MODIFY_TABLE_CONTENT_PROPERTY,
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: true,
  },
};

const contentPropertyTypeModal: TableContentHeader = {
  contentProperties: [
    {
      key: 'businessId',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessId'], propertyType: 'string' },
    },
    {
      key: 'UnmanagedBusinessWarehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'UnmanagedBusinessSupplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'manufacturer',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['manufacturer'], propertyType: 'string' },
    },
    {
      key: 'businessNumberNamedByUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumberNamedByUser'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: true,
  },
};

const contentPropertyTypeModalWhenAggregateRow: TableContentHeader = {
  contentProperties: [
    {
      key: 'businessId',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['businessId'], propertyType: 'string' },
    },
    {
      key: 'UnmanagedBusinessWarehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'UnmanagedBusinessSupplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'businessNumberNamedByUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumberNamedByUser'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'UnmanagedBusinessCustomerNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['customerNumber'], propertyType: 'string' },
    },
    {
      key: 'customerName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['customerName'], propertyType: 'string' },
    },
    {
      key: 'UnmanagedBusinessSalesDestinationNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['salesDestinationNumber'], propertyType: 'string' },
    },
    {
      key: 'deliveryDestinationName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['deliveryDestinationName'], propertyType: 'string' },
    },
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: true,
  },
};

export const contentPropertyType = {
  [ImportFileType.Announce]: contentPropertyTypeAnnounce,
  [ImportFileType.SalesResult]: contentPropertyTypeSalesResult,
  [ImportFileType.Inventory]: contentPropertyTypeInventory,
  [ImportFileType.Arrival]: contentPropertyTypeArrival,
  modal: contentPropertyTypeModal,
  modalWhenAggregateRow: contentPropertyTypeModalWhenAggregateRow,
} as const;
